import React from 'react';
import { useTranslation } from 'react-i18next';
import { CSSTransition } from 'react-transition-group';
import { useModal } from '@context/ModalContext';

import bgStars from '/img/icons/stars.png';
import TcoinPNG from '/img/icons/tcoin.png';
import TcoinWEBP from '/img/icons/tcoin.webp';

const ModalTcoinExplain: React.FC = () => {
  const { openTCoinModal, setOpenTCoinModal } = useModal();
  const { t } = useTranslation();

  return (
    <div
      className={`modalUpdateBackground modalTcoin ${openTCoinModal ? 'open' : ''}`}
    >
      <CSSTransition
        in={openTCoinModal}
        timeout={300}
        classNames="my-node-modal"
        unmountOnExit
      >
        <div id="update-modal" className="page page--mine modalUpdate">
          <button
            style={{ background: 'var(--white-10, #FFFFFF1A)' }}
            data-fancybox-close=""
            className="f-button is-close-btn"
            title="Close"
            onClick={() => setOpenTCoinModal(false)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              style={{ strokeWidth: '4px' }}
            >
              <path d="M20 20L4 4m16 0L4 20"></path>
            </svg>
          </button>
          <div className="update-modal">
            <div
              className="update-modal__inner tcoin-container"
              style={{
                backgroundImage: `url(${bgStars})`,
              }}
            >
              <div>
                <picture>
                  <source srcSet={TcoinWEBP} type="image/webp" />
                  <img
                    src={TcoinPNG}
                    alt="build"
                    width={196}
                    style={{ margin: 'auto' }}
                  />
                </picture>
              </div>
              <span className="top-gradient"></span>

              <div className="update-modal__body">
                <div className="update-modal__head">
                  <h2 className="popup-title" style={{ marginBottom: '8px' }}>
                    T-Coin
                  </h2>
                  <div className="popup-description">
                    <p className="popup-description-text tcoin-text">
                      {t(
                        'Earn T-Coin by completing tasks and achieving in-game goals. T-Coin is a strategically important currency that can be used to obtain exclusive rewards, activate special features, accelerate progress, and enhance your gaming experience, playing a key role in the prosperity of your empire',
                      )}
                    </p>
                  </div>
                </div>
                <button
                  type="button"
                  className="btn"
                  style={{ marginTop: '100px' }}
                  onClick={() => setOpenTCoinModal(false)}
                >
                  {t('I got it')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </CSSTransition>
    </div>
  );
};

export default ModalTcoinExplain;
